import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  // 获取排行榜
  getRankList: {
    custom: true,
    url: (activityId)=>`/apis/moyin-account/moyou/rank/rankList?activityId=${activityId}`,
    method: 'get'
  },
  // 查看礼品
  getAllReward: {
    custom: true,
    url: (activityId)=>`/apis/moyin-account/moyou/rank/getAllReward?activityId=${activityId}`,
    method: 'get'
  },
  // 获取自己的排名
  getMyRank: {
    custom: true,
    url: (data:any)=>`/apis/moyin-account/moyou/rank/queryRankByWwid?activityId=${data.activityId}`,
    method: 'get'
  },
  // 获取自己账户下名单
  getActivityUserAccount: {
    custom: true,
    url: (data:any)=>`/apis/moyin-account/moyou/rank/queryRankByWwidWithChild?activityId=${data.activityId}`,
    method: 'get'
  }
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"leaderboard"
  })
}